<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">产品</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">云服务器</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="se-panel-title">云服务器列表</div>
      </div>
      <div class="panel-body clearfix">
        <div class="ub-box z-margin-bottom-20-precent">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="BuyVps">购买</el-button>
          <div class="zj-select" style="margin-left: 25px">
            <el-input placeholder="关键词" v-model="search" class="input-with-select" @keyup.enter.native="SearchVps">
              <el-select v-model="key_type" slot="prepend" placeholder="全部">
                <el-option label="主机IP" value="ip"></el-option>
                <el-option label="名称/备注" value="remark"></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-search" @click="SearchVps"></el-button>
            </el-input>
          </div>
        </div>
        <el-table :data="vpsList" highlight-current-row show-header v-loading="listLoading" class="table-empty" @sort-change="sort" @cell-mouse-enter="tableEnter" @cell-mouse-leave="tableLeave" style="width: 100%;">
          <el-table-column prop="name" label="名称" min-width="100" align="left" sortable="custom">
            <template slot-scope="scope">
              {{scope.row.name}}
              <span v-show="scope.row.show === true" class="edit-name" title="修改名称" @click="EditName(scope.row.id,scope.row.ip,scope.row.name,scope.row.Bz1)"></span>
            </template>
          </el-table-column>
          <el-table-column prop="ip" label="IP地址" min-width="120" align="left">
            <template slot-scope="scope">
              <span v-if="scope.row.Pstate != '未初始化'">{{scope.row.ip}}</span>
              <el-button type="primary" size="mini" v-if="scope.row.Pstate === '未初始化'" @click="HostInit(scope.row.id)">点击一键初始化</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="OsType" label="操作系统" min-width="150" align="left">
          </el-table-column>
          <el-table-column prop="peizhi" label="服务器配置" min-width="150" align="left">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="12">实例：<span class="z-color-green z-font-weight-700">{{scope.row.cpu}}核/{{scope.row.ram}}G</span></el-col>
                <el-col :span="12">硬盘：<span class="z-color-green z-font-weight-700">{{scope.row.disk}}G</span></el-col>
              </el-row>
              <el-row>
                <el-col :span="12">带宽：<span class="z-color-green z-font-weight-700">{{scope.row.net}}M</span></el-col>
                <el-col :span="12">类型：<span class="z-color-green z-font-weight-700">{{scope.row.xianlu}}</span></el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="state" label="状态" align="center" min-width="100">
            <template slot-scope="scope">
              <i v-if="!scope.row.state" class="el-icon-loading"></i>
              <span v-if="scope.row.state">
                  <span v-if="scope.row.state.loading != 'ok' && scope.row.state.msg" class="z-color-green-state state-icon" :class="{'server-state-run':scope.row.state.msg.indexOf('运行') != -1,'server-state-stop':scope.row.state.msg.indexOf('关机') != -1}">{{scope.row.state.msg}}</span>
                  <i v-if="scope.row.state.loading === 'ok'" class="el-icon-loading z-font-size-16"></i>
                  <span v-if="scope.row.state.loading === 'ok'" class="z-color-red">{{scope.row.state.loading_txt}}</span>
                 （{{scope.row.state.Pstate}}）
                </span>
            </template>
          </el-table-column>
          <el-table-column prop="EndTime" label="到期时间" align="left" sortable="custom">
            <template slot-scope="scope">
              <span v-if="scope.row.EndTime.indexOf('2111') != 0" >{{scope.row.EndTime}}</span>
              <span v-if="scope.row.EndTime.indexOf('2111') == 0" class="z-color-red">终身VIP</span>
            </template>
          </el-table-column>
          <el-table-column prop="caozuo" label="操作" align="center">
            <template slot-scope="scope">
              <router-link v-if="scope.row.Pstate != '未初始化'" :to="'/server'+'/'+scope.row.id" class="z-color-a">管理</router-link>
              &nbsp;&nbsp;
              <span v-if="scope.row.Pstate != '未初始化' && scope.row.EndTime != '终身有效'" class="z-curPonit z-color-a" @click="Rennew(scope.row.id,scope.row.EndTime,scope.row.ip)">续费</span>
              &nbsp;&nbsp;
              <span v-if="scope.row.Pstate != '未初始化' && scope.row.EndTime != '终身有效'" class="z-curPonit z-color-a" @click="Shengji(scope.row.id,scope.row.EndTime,scope.row.ip,scope.row.cpu,scope.row.ram,scope.row.disk,scope.row.net)">升级</span>
            </template>
          </el-table-column>
          <el-table-column prop="Bz1" label="备注" align="left">
            <template slot-scope="scope">
              {{scope.row.Bz1}}
              <span v-show="scope.row.show === true" class="edit-name" title="修改备注" @click="EditBeizhu(scope.row.id,scope.row.ip,scope.row.name,scope.row.Bz1)"></span>
            </template>
          </el-table-column>
          <span slot="empty">
            云服务器列表为空，
            <a class="z-curPonit z-color-a" href="/server/" target="_blank">立即购买&gt;&gt;</a>
          </span>
        </el-table>
        <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="10" :total="total" class="pull-left">
        </el-pagination>
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="云服务器续费" :lock-scroll="false" :visible.sync="dialogXufei" @close="xufeiForm.region = '1'" width="660px">
      <el-form label-width="180px" class="xufei-form">
        <el-form-item label="IP地址：" size="mini">
          <span class="z-font-size-12 z-color-666">{{xufeiForm.ip}}</span>
        </el-form-item>
        <el-form-item label="到期时间：">
          <span class="z-font-size-12 z-color-666">{{xufeiForm.endtime}}</span>
        </el-form-item>
        <el-form-item label="续费时长：">
          <el-select v-model="xufeiForm.region">
            <el-option label="1月" value="1"></el-option>
            <el-option label="2月" value="2"></el-option>
            <el-option label="3月" value="3"></el-option>
            <el-option label="4月" value="4"></el-option>
            <el-option label="5月" value="5"></el-option>
            <el-option label="6月" value="6"></el-option>
            <el-option label="7月" value="7"></el-option>
            <el-option label="8月" value="8"></el-option>
            <el-option label="9月" value="9"></el-option>
            <el-option label="1年" value="12"></el-option>
            <el-option label="2年" value="24"></el-option>
            <el-option label="3年" value="36"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优惠券：">
          <el-select v-model="xufeiForm.coupon" placeholder="--请选择--" style="width: 300px">
            <el-option
              v-for="item in xufeiForm.yhq"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="续费后到期时间：">
          <span class="z-font-size-12 z-color-666">{{xufeiForm.newtime}}</span>
        </el-form-item>
        <el-form-item label="账户余额：">
          <span class="z-font-size-12 z-color-66-orange z-font-weight-700">{{xufeiForm.money}}元</span>
        </el-form-item>
        <el-form-item label="所需费用：">
          <span v-show="xufeiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">价格计算中...</span>
          <span v-show="!xufeiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">{{xufeiForm.price}}.</span>
          <span v-show="!xufeiForm.loading" class="z-font-size-12 z-color-66-orange">00元</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogXufei = false">取 消</el-button>
        <el-button type="primary" @click="Renew">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="云服务器变更配置" :lock-scroll="false" :visible.sync="dialogXLevel" @close="shengjiForm.cpu = '',shengjiForm.price = '0'" width="660px">
      <div class="alert-warn">
        服务器升级后，到期时间不变，差价的计算精确到天；<br>升级价格计算公式：(升级配置价格[月] - 原始配置价格[月]) * 12 / 365 * 到期剩余天数。<br>变更配置费用不足10元按10元计算
      </div>
      <el-form label-width="180px" class="xufei-form">
        <el-form-item label="IP地址：">
          <span class="z-font-size-12 z-color-666">{{shengjiForm.ip}}</span>
        </el-form-item>
        <el-form-item label="CPU：">
          <el-select v-model="shengjiForm.cpu" placeholder="--请选择--" style="width: 170px">
            <el-option
              v-for="item in shengjiForm.Cpu"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内存：">
          <el-select v-model="shengjiForm.ram" placeholder="--请选择--" style="width: 170px">
            <el-option
              v-for="item in shengjiForm.Ram"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="SSD数据盘：">
          <el-input-number v-model="shengjiForm.ssd" @change="changeSsd" controls-position="right" :step="10" :min="shengjiForm.minssd" :max="1000"></el-input-number>
          <span class="z-font-size-12 z-color-999" style="position: absolute;left: 76px;">GB</span>
        </el-form-item>
        <el-form-item label="公网带宽：">
          <el-input-number v-model="shengjiForm.bandwidth" @change="changeBandwidth" controls-position="right" :min="5" :max="300"></el-input-number>
          <span class="z-font-size-12 z-color-999" style="position: absolute;left: 62px;">Mbps</span>
        </el-form-item>
        <el-form-item label="优惠券：">
          <el-select v-model="shengjiForm.coupon" placeholder="--请选择--" style="width: 300px">
            <el-option
              v-for="item in shengjiForm.yhq"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到期时间：">
          <span class="z-font-size-12 z-color-666">{{shengjiForm.endtime}}</span>
        </el-form-item>
        <el-form-item label="账户余额：">
          <span class="z-font-size-12 z-color-66-orange z-font-weight-700">{{shengjiForm.money}}元</span>
        </el-form-item>
        <el-form-item label="所需费用：">
          <span v-show="shengjiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">价格计算中...</span>
          <span v-show="!shengjiForm.loading" class="z-font-size-16 z-color-66-orange z-font-weight-700">{{shengjiForm.price}}.</span>
          <span v-show="!shengjiForm.loading" class="z-font-size-12 z-color-66-orange">00元</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogXLevel = false">取 消</el-button>
        <el-button type="primary" @click="Level">确 定</el-button>
      </div>
    </el-dialog>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
    <el-dialog
      title="实例名称"
      :visible.sync="dialogEditname"
      top="12%"
      width="500px"
      :lock-scroll=false
      :close-on-click-modal=false
      :close-on-press-escape=false
      custom-class="dialog">
      <div class="alert-warn">
        注：修改后方便于管理，不会影响服务器配置，请您放心操作。
      </div>
      <el-form label-width="135px" label-position="right">
        <el-form-item label="IP地址：">
          {{editForm.ip}}
        </el-form-item>
        <el-form-item label="自定义名称：">
          <el-input v-model="editForm.name" style="width: 200px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="RemarkEdit">确 定</el-button>
            <el-button @click="dialogEditname = false">取 消</el-button>
          </span>
    </el-dialog>
    <el-dialog
      title="备注"
      :visible.sync="dialogEditBeizhu"
      top="12%"
      width="500px"
      :lock-scroll=false
      :close-on-click-modal=false
      :close-on-press-escape=false
      custom-class="dialog">
      <div class="alert-warn">
        注：修改后方便于管理，不会影响服务器配置，请您放心操作。
      </div>
      <el-form label-width="135px" label-position="right">
        <el-form-item label="IP地址：">
          {{editForm.ip}}
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="editForm.beizhu" style="width: 200px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="RemarkEdit">确 定</el-button>
            <el-button @click="dialogEditBeizhu = false">取 消</el-button>
          </span>
    </el-dialog>
    <!--blackpink-->
    <div v-if="dialogShadow" class="dialogShadow"></div>
    <dl v-if="dialogShadow" class="dialogBody ub-box ub-col">
      <dd class="dialogTitle z-font-size-16">
        <span class="z-font-size-18 z-padding-left-10-precent">提示信息</span>
        <a class="aui_close" href="javascript:;" @click="clickBtn()">×</a>
      </dd>
      <dd class="dialogContent z-color-666 z-font-size-15 ">
        <img style="margin-left: 30px;margin-right: 30px;vertical-align: middle" src="../../assets/imgs/uc_warn.png" alt="">
        <span class="z-font-size-15" >您的帐户还没有实名认证</span>
        <br>
        <router-link to="/auth" class="z-color-a z-font-size-15" style="display: inline-block;margin-left: 127px">点击这里实名认证</router-link>
      </dd>
      <div class="dialogFooter ub-f1 ub-box ub-ver z-padding-v-15-precent">
        <!--<dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(true)" style="background:#2ebace;">确认</dd>
        <dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(false)" style="">取消</dd>-->
      </div>
    </dl>
  </div>
</template>
<script>
  import VpsService from 'business/VpsService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import userService from 'business/userService.js'
  import renewService from 'business/renewService.js'
  import upgradeService from 'business/upgradeService.js'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        vpsList:[],
        dialogLoading:false,
        listLoading:false,
        showempty:false,
        dialogXufei:false,
        dialogXLevel:false,
        dialogEditname:false,
        dialogEditBeizhu:false,
        dialogShadow:false,
        errorMsg:'',
        activeNames:'index',
        input:'',
        userList: [],
        search:'',
        key_type:'ip',
        orderby:'Bz2',
        ordertype:'desc',
        xufeiForm:{
          id:'',
          ip:'',
          endtime:'',
          region: '1',
          coupon:'',
          yhq:[],
          newtime:'',
          price:'',
          loading:false,
          money:''
        },
        shengjiForm:{
          ip:'',
          cpu:'',
          Cpu:[
            {
              value: '1',
              label: '1核'
            },
            {
              value: '2',
              label: '2核'
            },
            {
              value: '4',
              label: '4核'
            },
            {
              value: '8',
              label: '8核'
            },
            {
              value: '16',
              label: '16核'
            },
          ],
          ram:'',
          Ram:[
            {
              value: '1',
              label: '1G'
            },
            {
              value: '2',
              label: '2G'
            },
            {
              value: '4',
              label: '4G'
            },
            {
              value: '8',
              label: '8G'
            },
          ],
          ssd:1,
          minssd:1,
          bandwidth:1,
          minbandwidth:1,
          coupon:'',
          yhq:[],
          endtime:'',
          price:'0',
          loading:false,
          money:''
        },
        editForm:{
          id:'',
          ip:'',
          name:'',
          beizhu:''
        },
        count:10,
        total:0,
        page:1,
      }
    },
    components:{
      XdialogLoading,
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.SearchVps()
    },
    computed: {
      region() {
        return this.xufeiForm.region
      },
      coupon() {
        return this.xufeiForm.coupon
      },
      coupon2() {
        return this.shengjiForm.coupon
      },
      cpu() {
        return this.shengjiForm.cpu
      },
      ram() {
        return this.shengjiForm.ram
      },
    },
    watch:{
      region(){
        this.getPrice()
      },
      coupon(){
        this.getPrice()
      },
      coupon2() {
        this.levelPrice()
      },
      cpu(val,oldval){
        if(val === '1'){
          this.shengjiForm.Ram = [
            {
              value: '1',
              label: '1G'
            },
            {
              value: '2',
              label: '2G'
            },
            {
              value: '4',
              label: '4G'
            },
            {
              value: '8',
              label: '8G'
            },
          ]
        }
        if(val === '2'){
          this.shengjiForm.Ram = [
            {
              value: '2',
              label: '2G'
            },
            {
              value: '4',
              label: '4G'
            },
            {
              value: '8',
              label: '8G'
            },
            {
              value: '16',
              label: '16G'
            },
          ]
        }
        if(val === '4'){
          this.shengjiForm.Ram = [
            {
              value: '4',
              label: '4G'
            },
            {
              value: '8',
              label: '8G'
            },
            {
              value: '16',
              label: '16G'
            },
            {
              value: '32',
              label: '32G'
            },
          ]
        }
        if(val === '8'){
          this.shengjiForm.Ram = [
            {
              value: '8',
              label: '8G'
            },
            {
              value: '16',
              label: '16G'
            },
            {
              value: '32',
              label: '32G'
            },
            {
              value: '64',
              label: '64G'
            },
          ]
        }
        if(val === '16'){
          this.shengjiForm.Ram = [
            {
              value: '16',
              label: '16G'
            },
            {
              value: '32',
              label: '32G'
            },
            {
              value: '64',
              label: '64G'
            },
          ]
        }
        if(oldval != '' && val != ''){
          this.shengjiForm.ram = this.shengjiForm.Ram[0].value
          this.levelPrice()
        }
      },
      ram(val,oldval){
        this.levelPrice()
      },
    },
    methods:{
      ...mapActions(['VPS']),
      async SearchVps(sort) {
        this.listLoading = true
        let data
        if(sort){
          data = 'cmd=vps_list'+
            '&count='+ this.count +
            '&page='+ this.page +
            '&key_type='+ this.key_type +
            '&keyword='+ this.search +
            '&orderby='+ this.orderby +
            '&ordertype='+ this.ordertype
        }else{
          data = 'cmd=vps_list'+
            '&count='+ this.count +
            '&page='+ this.page +
            '&key_type='+ this.key_type +
            '&keyword='+ this.search
        }
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total = vueData.msg.allcount
          this.vpsList = vueData.msg.content.map((item, index) => {
            return {
              show:false,
              id:item.id,
              Pstate:item.Pstate,
              name:item.vps_name,
              ip:item.ip,
              OsType:item.OsType,
              cpu:item.CPU,
              ram:item.RAM,
              disk:item.SSD,
              net:item.NET_WIDTH,
              xianlu:item.NET_TYPE,
              EndTime:item.EndTime,
              Bz1:item.vps_remark,
              state:this.VpsState(item.id) ? false : false,
            }
          })
          this.showempty = true
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async VpsState(id) {
        let data = 'cmd=get_vps_state'+
          '&id='+ id
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(state.code === '000') {
          this.vpsList.map((item, index) => {
            if(id == item.id){
              item.state = vueData
            }
          })
        }else {
          this.$toast('刷新试一下','fail')
        }
      },
      sort(obj){
        switch (obj.prop) {
          case 'name':
            this.orderby = 'Bz2'
            break
          case 'EndTime':
            this.orderby = 'EndTime'
            break
        }
        switch (obj.order) {
          case 'ascending':
            this.ordertype = 'asc'
            break
          case 'descending':
            this.ordertype = 'desc'
            break
        }
        this.SearchVps(true)
      },
      handleCurrentChange(val) {
        this.page = val;
        this.SearchVps()
      },
      handleSizeChange(val) {
        this.count = val
        this.SearchVps()
      },
      tableEnter(row, column, cell, event) {
        row.show = true
      },
      tableLeave(row, column, cell, event) {
        row.show = false
      },
      EditName(id,ip,name,beizhu){
        this.editForm.id = id
        this.editForm.ip = ip
        this.editForm.name = name
        this.editForm.beizhu = beizhu
        this.dialogEditname = true
      },
      EditBeizhu(id,ip,name,beizhu){
        this.editForm.id = id
        this.editForm.ip = ip
        this.editForm.name = name
        this.editForm.beizhu = beizhu
        this.dialogEditBeizhu = true
      },
      async RemarkEdit() {
        this.dialogLoading = true
        let data = 'cmd=remark_edit'+
          '&id='+ this.editForm.id +
          '&vps_remark='+ this.editForm.beizhu +
          '&vps_name='+ this.editForm.name
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.dialogEditname = false
              self.dialogEditBeizhu = false
              self.SearchVps()
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      BuyVps () {
        window.open("https://www.abeiyun.com/server/")
      },
      Rennew(id,endtime,ip) {
        this.xufeiForm.id = id
        this.xufeiForm.endtime = endtime
        this.xufeiForm.ip = ip
        this.dialogXufei = true
        this.couponInfo()
        this.getPrice()
      },
      async Shengji(id,endtime,ip,cpu,ram,ssd,bandwidth) {
        this.shengjiForm.id = id
        this.shengjiForm.endtime = endtime
        this.shengjiForm.ip = ip
        this.shengjiForm.cpu = cpu.replace('核','')
        this.shengjiForm.ram = ram.replace('G','')
        this.shengjiForm.ssd = Number(ssd.replace('G',''))
        this.shengjiForm.minssd = Number(ssd.replace('G',''))
        this.shengjiForm.bandwidth = Number(bandwidth.replace('M',''))
        this.shengjiForm.minbandwidth = Number(bandwidth.replace('M',''))
        this.dialogXLevel = true
        this.couponInfo()
      },
      async HostInit(id){
        this.dialogLoading = true
        let data = 'cmd=vps_init'+
          '&id='+ id
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.SearchVps()}})
        }else {
          this.dialogLoading = false
          if(vueData.msg === 'smrz_fail'){
            this.dialogShadow = true
          }else {
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }
      },
      async getPrice() {
        this.xufeiForm.loading = true
        let data = 'cmd=renew'+
          '&yewu_type=vps'+
          '&yewu_id='+ this.xufeiForm.id +
          '&renew_time='+ this.xufeiForm.region +
          '&yhq_id='+ this.xufeiForm.coupon +
          '&ac_type=getprice'
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',data)
        if(vueData.response == 200 ) {
          this.xufeiForm.loading = false
          this.xufeiForm.name = vueData.pname
          this.xufeiForm.ftp = vueData.ftp_user
          this.xufeiForm.newtime = vueData.endtime
          this.xufeiForm.price = vueData.price
        }else {
          let self = this
          this.$dialog({type:'error', info: vueData.msg, click () {
              self.xufeiForm.coupon = ''
            }})
        }
      },
      async couponInfo() {
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=userinfo')
        if(state.code === '000' ) {
          this.xufeiForm.money = vueData.msg.money
          this.shengjiForm.money = vueData.msg.money
          this.shengjiForm.yhq = vueData.msg.yhq.onuse.map((item, index) => {
            return {
              value: item.yhq_id,
              label: item.yhq_id+'(可优惠'+ item.money_all +'元，最低消费满'+ item.money_need +'元可使用)',
              yhq_use: item.yhq_use
            }
          })
          this.xufeiForm.yhq = vueData.msg.yhq.onuse.map((item, index) => {
            return {
              value: item.yhq_id,
              label: item.yhq_id+'(可优惠'+ item.money_all +'元，最低消费满'+ item.money_need +'元可使用)',
              yhq_use: item.yhq_use
            }
          })
          this.xufeiForm.yhq.unshift({
            value: '',
            label: '不使用优惠券',
            yhq_use: ''
          })
          this.shengjiForm.yhq.unshift({
            value: '',
            label: '不使用优惠券',
            yhq_use: ''
          })
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      async Renew() {
        this.dialogLoading = true
        let data = 'cmd=renew'+
          '&yewu_type=vps'+
          '&yewu_id='+ this.xufeiForm.id +
          '&renew_time='+ this.xufeiForm.region +
          '&yhq_id='+ this.xufeiForm.coupon +
          '&ac_type=renew'
        let {vueData, state} = await renewService.transformToVue('renewInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.dialogXufei = false
              self.SearchVps()
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      changeSsd(ssd) {
        this.shengjiForm.ssd = ssd
        this.levelPrice()
      },
      changeBandwidth(bandwidth) {
        this.shengjiForm.bandwidth = bandwidth
        this.levelPrice()
      },
      async levelPrice() {
        this.shengjiForm.loading = true
        let data = 'cmd=vps_price'+
          '&yewu_id='+ this.shengjiForm.id +
          '&CPU='+ this.shengjiForm.cpu +
          '&RAM='+ this.shengjiForm.ram +
          '&SSD='+ this.shengjiForm.ssd +
          '&NET_WIDTH='+ this.shengjiForm.bandwidth +
          '&yhq_id='+ this.shengjiForm.coupon
        let {vueData, state} = await upgradeService.transformToVue('upgradeInfo','POST',data)
        if(vueData.response == 200 ) {
          this.shengjiForm.loading = false
          this.shengjiForm.price = vueData.msg
        }else if(vueData.msg === '当前配置没有更改！'){
          this.shengjiForm.loading = false
          this.shengjiForm.price = 0
        } else {
          this.shengjiForm.loading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async Level() {
        this.dialogLoading = true
        let data = 'cmd=vps_upgrade'+
          '&yewu_id='+ this.shengjiForm.id +
          '&CPU='+ this.shengjiForm.cpu +
          '&RAM='+ this.shengjiForm.ram +
          '&SSD='+ this.shengjiForm.ssd +
          '&NET_WIDTH='+ this.shengjiForm.bandwidth+
          '&yhq_id='+ this.shengjiForm.coupon
        let {vueData, state} = await upgradeService.transformToVue('upgradeInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.dialogXLevel = false
              self.SearchVps()
            }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      clickBtn() {
        this.dialogShadow = false
      }
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }
  .xufei-form .el-input,.el-select {
    width: 140px;
  }
  .input-with-select .el-input-group__prepend .el-select {
    width: 100px;
  }
  .alert-warn {
    margin-bottom: 20px;
  }
  .edit-name {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url(../../assets/imgs/server_edit.png) no-repeat center;
    vertical-align: -1.5px;
    cursor: pointer;
  }
  .state-icon {
    padding-left: 22px;
    background: no-repeat left center;
  }
  .server-state-run {
    background-image: url(../../assets/imgs/server_state_run.png);
    color: #29cc7a;
  }
  .server-state-stop {
    background-image: url(../../assets/imgs/server_state_stop.png?v=2);
    color: #ff0000;
  }

  .dialogShadow{position:fixed;z-index:9900;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);}
  .dialogBody{position:fixed;z-index:9909;top:37%;left:50%;transform:translateX(-50%);min-width:32rem;background:#fff;box-shadow: 0 0 10px 3px rgba(0,0,0,.2);animation:dialogAnimStart .2s forwards}
  .dialogTitle{position:relative;padding:1rem 0;background:#f7f9fa;color:#636566;}
  .dialogContent{padding: 2rem 2rem 2rem 0}
  .dialogFooter{background:#f7f9fa;}
  @keyframes dialogAnimEnd{
    from{opacity:1}
    to{opacity:0}
  }
  .aui_close {
    position: absolute;
    padding: 0;
    top: 31%;
    right: 22px;
    width: 21px;
    height: 21px;
    line-height: 21px;
    font-size: 30px;
    color: #636566;
    text-align: center;
    font-family: Helvetica, STHeiti;
  }
</style>




// WEBPACK FOOTER //
// src/pages/product/serverList.vue